import React, { useEffect, useRef } from 'react';

export default function VideoPreviewPlayer({ url, poster, title, onMetadata, onError }) {
  const ref = useRef(null);
  useEffect(() => {
    const player = ref.current;
    return () => {
      if (!player) return;
      player.pause();
      player.removeAttribute('src');
      player.load();
    };
  }, []);
  return <video ref={ref} src={url} poster={poster || undefined} controls playsInline preload="metadata"
    aria-label={`Play ${title}`} onError={onError}
    onLoadedMetadata={event => onMetadata({ duration: event.currentTarget.duration, width: event.currentTarget.videoWidth, height: event.currentTarget.videoHeight })}
    style={{ width: '100%', height: '100%', minHeight: 0, objectFit: 'contain', display: 'block', background: '#080a0c' }} />;
}
